<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../eventBus.js'

export default {
  name: 'runner-profile-dashboard',
  components: {

  },
  props: [],
  data() {
    return {
        currentTab: 0,
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    changeTab(tab) {
        this.currentTab = tab;
    }
  },
  watch: {

  }
}
</script>
